/**
 * Minified by jsDelivr using Terser v5.19.2.
 * Original file: /npm/minisearch@7.1.1/dist/umd/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
